import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'
import colors from '../../theme/foundations/colors'
import sizes from '../../theme/foundations/sizes'

export const orderSummaryHeading = {
    color: 'black',
    marginTop: pxToRem(23),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(22),
    fontWeight: '600',
    lineHeight: 'normal',
    letterSpacing: pxToRem(3),
    textTransform: 'uppercase',
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(20),
        fontSize: pxToRem(18)
    }
}

export const subtotalStyle = {
    color: 'black',
    marginTop: pxToRem(32),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(20),
        fontSize: pxToRem(14)
    }
}

export const currencyStyle = {
    color: 'black',
    marginTop: pxToRem(32),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(20),
        fontSize: pxToRem(14)
    }
}

export const shippingStyle = {
    color: 'black',
    marginTop: pxToRem(25),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const giftCardStyle = {
    color: 'cav_red',
    marginTop: pxToRem(25),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const shippingCurrencyStyle = {
    color: 'black',
    marginTop: pxToRem(25),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const salesTaxStyle = {
    color: 'black',
    marginTop: pxToRem(25),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const salesTaxCurrencyStyle = {
    color: 'black',
    marginTop: pxToRem(25),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const freeTextStyle = {
    color: 'black',
    marginTop: pxToRem(25),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const tbdStyle = {
    marginTop: pxToRem(25),
    marginBottom: '0px',
    lineHeight: 'normal',
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(15),
        fontSize: pxToRem(14)
    }
}

export const noteStyle = {
    color: 'cav_light_input_gray',
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    marginTop: `${pxToRem(10)} !important`,
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: `${pxToRem(5)} !important`,
        fontSize: pxToRem(12)
    }
}

export const estimatedTotalStyle = {
    color: 'black',
    marginTop: pxToRem(20),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(14)
    }
}

export const estimatedCurrencyStyle = {
    color: 'black',
    marginTop: pxToRem(20),
    marginBottom: '0px',
    fontFamily: fonts.primary,
    fontSize: pxToRem(16),
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(14)
    }
}

export const checkoutButtonStyle = {
    marginTop: pxToRem(45),
    backgroundColor: 'cav_red',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: pxToRem(14),
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    width: '100%',
    height: pxToRem(40),
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    borderRadius: '0px',
    '&:hover': {
        border: `${pxToRem(1)} solid ${colors.cav_red}`,
        borderRadius: '0px',
        textDecoration: 'none',
        backgroundColor: 'white',
        color: 'cav_red'
    },
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(20),
        fontSize: pxToRem(12)
    }
}

export const applyButtonStyle = {
    backgroundColor: 'cav_red',
    textAlign: 'center',
    fontFamily: fonts.primary,
    fontSize: pxToRem(14),
    fontWeight: '700',
    lineHeight: pxToRem(13.5),
    letterSpacing: pxToRem(1.5),
    textTransform: 'uppercase',
    width: pxToRem(92),
    height: pxToRem(40),
    padding: `${pxToRem(12)} ${pxToRem(20)}`,
    borderRadius: '0px',
    '&:hover': {
        border: `${pxToRem(1)} solid ${colors.cav_red}`,
        borderRadius: '0px',
        textDecoration: 'none',
        backgroundColor: 'white',
        color: 'cav_red'
    },
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(12)
    }
}

export const iconStyle = {
    marginTop: pxToRem(25),
    marginBottom: pxToRem(23),
    [`@media (max-width: ${sizes.container.md})`]: {
        marginTop: pxToRem(10),
        marginBottom: pxToRem(20)
    }
}

export const editCartItemStyle = {
    marginTop: {
        base: pxToRem(21),
        md: pxToRem(31)
    },
    color: 'cav_red',
    fontFamily: fonts.primary,
    fontSize: {
        base: pxToRem(14),
        md: pxToRem(16)
    },
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}
export const editCartButtonStyle = {
    width: '100%',
    color: 'cav_red',
    fontFamily: fonts.primary,
    fontSize: {
        base: pxToRem(10),
        md: pxToRem(12)
    },
    fontWeight: '500',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    textTransform: 'uppercase',
    textDecoration: 'none', // base style
    _hover: {
        textDecoration: 'none' // on hover
    },
    _focus: {
        textDecoration: 'none' // optional, for keyboard focus
    }
}

export const promotionCodeLabelStyle = {
    color: 'black',
    marginBottom: [pxToRem(10)],
    marginTop: [pxToRem(20)],
    fontFamily: fonts.primary,
    fontSize: [pxToRem(14), pxToRem(16), pxToRem(16), pxToRem(16)],
    fontWeight: '400',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}
